// Core domain types shared across the platform
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["OPERATOR"] = "OPERATOR";
    UserRole["ADVERTISER"] = "ADVERTISER";
    UserRole["VIEWER"] = "VIEWER";
})(UserRole || (UserRole = {}));
export var Orientation;
(function (Orientation) {
    Orientation["LANDSCAPE"] = "LANDSCAPE";
    Orientation["PORTRAIT"] = "PORTRAIT";
})(Orientation || (Orientation = {}));
export var ScreenStatus;
(function (ScreenStatus) {
    ScreenStatus["ONLINE"] = "ONLINE";
    ScreenStatus["OFFLINE"] = "OFFLINE";
    ScreenStatus["PAIRING"] = "PAIRING";
    ScreenStatus["ERROR"] = "ERROR";
})(ScreenStatus || (ScreenStatus = {}));
export var AssetType;
(function (AssetType) {
    AssetType["IMAGE"] = "IMAGE";
    AssetType["VIDEO"] = "VIDEO";
})(AssetType || (AssetType = {}));
export var AssetStatus;
(function (AssetStatus) {
    AssetStatus["DRAFT"] = "DRAFT";
    AssetStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    AssetStatus["APPROVED"] = "APPROVED";
    AssetStatus["ARCHIVED"] = "ARCHIVED";
})(AssetStatus || (AssetStatus = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["DRAFT"] = "DRAFT";
    CampaignStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CampaignStatus["APPROVED"] = "APPROVED";
    CampaignStatus["ACTIVE"] = "ACTIVE";
    /** Temporarily off-air: excluded from manifests but resumable (→ ACTIVE). */
    CampaignStatus["PAUSED"] = "PAUSED";
    CampaignStatus["COMPLETED"] = "COMPLETED";
    CampaignStatus["CANCELLED"] = "CANCELLED";
    /** Terminal record-keeping state: hidden from default lists, never compiled. */
    CampaignStatus["ARCHIVED"] = "ARCHIVED";
})(CampaignStatus || (CampaignStatus = {}));
export var PairingStatus;
(function (PairingStatus) {
    PairingStatus["PENDING"] = "PENDING";
    PairingStatus["CONFIRMED"] = "CONFIRMED";
    PairingStatus["COMPLETED"] = "COMPLETED";
    PairingStatus["EXPIRED"] = "EXPIRED";
})(PairingStatus || (PairingStatus = {}));
//# sourceMappingURL=types.js.map